import { render, staticRenderFns } from "./DeleteGroupModal.vue?vue&type=template&id=223cceb1&scoped=true"
import script from "./DeleteGroupModal.vue?vue&type=script&lang=js"
export * from "./DeleteGroupModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteGroupModal.vue?vue&type=style&index=0&id=223cceb1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223cceb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('223cceb1')) {
      api.createRecord('223cceb1', component.options)
    } else {
      api.reload('223cceb1', component.options)
    }
    module.hot.accept("./DeleteGroupModal.vue?vue&type=template&id=223cceb1&scoped=true", function () {
      api.rerender('223cceb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/DeleteGroupModal.vue"
export default component.exports